<template>
  <div>
    <div class="card border-0 rounded shadow">
      <div class="card-body">
        <SenderAddressForm />
      </div>
    </div>
    <div class="card border-0 rounded shadow">
      <div class="card-body">
        <SenderBasicDataForm />
      </div>
    </div>
  </div>
</template>
<script>
import SenderAddressForm from "./SenderAddressForm.vue";
import SenderBasicDataForm from "./SenderBasicDataForm.vue";
export default {
  components: {
    SenderBasicDataForm,
    SenderAddressForm
  },
  data() {
    return {};
  }
};
</script>
